import PropTypes from 'prop-types';
import { Profiler } from '@eti/utils';
import { useProperty } from '@eti/providers';
import SeatMapProduct from '../containers/SeatMapProductContainer';
import PersuasionModalProvider from '../../common/context/PersuasionModalContext';
import SeatMapDialog from '../dialog/components/SeatMapDialog';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const readMore = {
  isEnabled: true
};
const SeatMap = _ref => {
  let {
    bounds = [],
    brand,
    buttonType,
    className,
    errors,
    form,
    highlightedInformation,
    isNeutral,
    isPostBooking,
    isSeatMapModalOpen,
    isSelected,
    persuasion,
    priceRaw,
    productSpecificTexts,
    seatMapCallback,
    selectedSeats = [],
    setIsSeatMapModalOpen,
    shouldShowImage = true,
    shouldShowMandatoryChoiceText,
    travelers
  } = _ref;
  const {
    p
  } = useProperty();

  // Always not forced on post booking
  const isForcedOnSubmit = form === 'products' ? false : p('IbeClient.TravelerDetails.Modal') === 'SEATMAP';
  return /*#__PURE__*/_jsx(Profiler, {
    id: "TravelerDetails-SeatMap",
    children: /*#__PURE__*/_jsxs(PersuasionModalProvider, {
      children: [/*#__PURE__*/_jsx(SeatMapProduct, {
        bounds: bounds,
        brand: brand,
        buttonType: buttonType,
        className: className,
        errors: errors,
        form: form,
        highlightedInformation: highlightedInformation,
        isForcedOnSubmit: isForcedOnSubmit,
        isNeutral: isNeutral,
        isSelected: isSelected,
        persuasion: persuasion,
        priceRaw: priceRaw,
        readMore: readMore,
        selectedSeats: selectedSeats,
        setIsSeatMapModalOpen: setIsSeatMapModalOpen,
        shouldShowImage: shouldShowImage,
        shouldShowMandatoryChoiceText: shouldShowMandatoryChoiceText
      }), /*#__PURE__*/_jsx(SeatMapDialog, {
        bounds: bounds,
        callback: seatMapCallback,
        form: form,
        isPostBooking: isPostBooking,
        productSpecificTexts: productSpecificTexts,
        setIsSeatMapModalOpen: setIsSeatMapModalOpen,
        show: isSeatMapModalOpen,
        travelers: travelers
      })]
    })
  });
};
SeatMap.propTypes = {
  bounds: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string
  })),
  brand: PropTypes.string,
  buttonType: PropTypes.oneOf(['highlighted']),
  className: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.object),
  form: PropTypes.string,
  highlightedInformation: PropTypes.shape({
    isEnabled: PropTypes.bool
  }),
  isNeutral: PropTypes.bool,
  isPostBooking: PropTypes.bool,
  isSeatMapModalOpen: PropTypes.bool,
  isSelected: PropTypes.bool,
  persuasion: PropTypes.shape({
    isEnabled: PropTypes.bool
  }),
  priceRaw: PropTypes.number,
  productSpecificTexts: PropTypes.shape({
    seatMapSegmentTexts: PropTypes.arrayOf(PropTypes.shape({
      boundIndex: PropTypes.number,
      segmentIndex: PropTypes.number,
      text: PropTypes.string
    }))
  }),
  readMore: PropTypes.shape({
    isEnabled: PropTypes.bool
  }),
  seatMapCallback: PropTypes.func,
  selectedSeats: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.arrayOf(PropTypes.any)]),
  setIsSeatMapModalOpen: PropTypes.func,
  shouldShowImage: PropTypes.bool,
  shouldShowMandatoryChoiceText: PropTypes.bool,
  travelers: PropTypes.arrayOf(PropTypes.shape({
    ageType: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }))
};
export default SeatMap;